import React from 'react'
import './style.scss'

class AboutMe extends React.Component {
  render() {
    return (
      <div>
        <h1 className="about__title">About Me</h1>
        <p> I am a software engineer who has extensive experience in building front-end applications for mobile and the web. Off-late, I have been having the time of my life exploring Distributed Systems.</p>
        <p> Although, I am not actively looking at freelancing at the moment, I am always up for a chat to discuss ideas or anything for that matter. Feel free to ping me on any of the communication platforms provided. </p>
      </div>

    )
  }
}

export default AboutMe
